import { t } from "i18next";
import * as yup from "yup";

export const staffManagerSchema = yup.object({
  id: yup.string().nullable(),
  firstName: yup.string().required(t("First name is requited")),
  lastName: yup.string().required(t("Last name is requited")),
  email: yup
    .string()
    .required(t("Email is requited"))
    .email(t("Invalid email format")),
  password: yup
    .string()
    .when("id", {
      is: undefined,
      then: () =>
        yup
          .string()
          .required(t("Password is requited"))
          .min(8, t("Password must be at least 8 characters long"))
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-:^#]{8,}$/,
            t(
              "Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
            )
          )
    })
    .test("min", t("Password must be at least 8 characters long"), (value) =>
      value ? value.length >= 8 : true
    )
    .test(
      "match",
      t(
        "Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
      ),
      (value) =>
        value
          ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-:^#]{8,}$/.test(
              value
            )
          : true
    ),

  repeatPassword: yup
    .string()
    .oneOf([yup.ref("password")], t("Passwords must match")),
  privileges: yup
    .array()
    .typeError(t("Privileges must be an array"))
    .of(yup.string())
    .min(1, t("Privileges should have at least one selected value"))
});
